module.exports = __webpack_public_path__ + "img/pcb_04.13969551.png";